module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-block__content"
  }, [_c('h2', {
    staticClass: "h2 home-block__heading mt0"
  }, [_vm._v("\n    " + _vm._s(_vm.content.heading) + "\n  ")]), _vm._v(" "), (_vm.content.subheading) ? _c('h3', {
    staticClass: "h3 home-block__subheading fw-semibold"
  }, [_vm._v("\n    " + _vm._s(_vm.content.subheading) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.content.copy), function(paragraph, index) {
    return _c('p', {
      key: index,
      class: [
        "p",
        index + 1 === _vm.content.copy.length ? "mb0" : "" ]
    }, [_vm._v("\n    " + _vm._s(paragraph) + "\n  ")])
  }), _vm._v(" "), (_vm.content.list) ? _c('div', {
    staticClass: "home-block__list"
  }, [_c('ul', _vm._l((_vm.content.list), function(point, index) {
    return _c('li', {
      key: index,
      staticClass: "home-block__list-item"
    }, [(_vm.content.bullet) ? _c('img', {
      attrs: {
        "src": _vm.content.bullet,
        "alt": "bullet"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(point))])])
  }))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60de1d6e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/HomeContent.vue
// module id = 253
// module chunks = 0